"use client"
import { Component } from "react"
import { Link } from "react-router-dom"
import { Box, Button, Tooltip, tooltipClasses } from "@mui/material"
import { styled } from "@mui/material/styles"
import moment from "moment"
import Colors from "../common/Colors"
import Redux from "../common/Redux"
import links from "../routes/URL"
import LogoutButton from "./LogoutButton"
import API, { URL_PATH } from "../services/API"
import Text from "../components/Text"
import { logOut } from "../common/util"
import Notification from "../components/Notification"
import EtableNew from "../assets/EtableNew.png"
import routes from "../routes/URL"
import { initSocket } from "../services/socket"
import {
  LayoutDashboard,
  ChefHat,
  Store,
  Clock,
  MenuSquare,
  TableProperties,
  ClipboardList,
  Users,
  UserCog,
  Package,
  Receipt,
  ImageIcon,
  QrCode,
  Star,
  CreditCard,
  CopySlash,
  Landmark,
  UsersRound,
  Utensils,
  ShoppingBag,
  Calendar,
  Ticket,
} from "lucide-react"
import Toast from "./Toast"

// Create a custom styled tooltip with the desired background color
const DarkTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
  ({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#FFC857",
      color: "black",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
      fontSize: 13,
      fontWeight: 500,
      padding: "8px 12px",
      border: "1px solid #0A2A3F",
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: "#FFC857",
    },
  }),
)

// Menu items configuration - updated to include Support and Logout
// const menuItems = [
  const menuItems = (hotelSlug) => [
  // Dashboard - Should be first
  {
    accessKey: "hotel-dashboard",
    title: "Dashboard",
    icon: LayoutDashboard,
    iconSrc: "url",
    link: links.admin.dashboard.root(hotelSlug),
  },
  // Order Management Section
  {
    accessKey: "hotel-order",
    title: "KDS ",
    featureKey: "KOT",
    icon: ChefHat,
    iconSrc: "url",
    link: links.admin.kot.root(hotelSlug),
  },
  {
    accessKey: "hotel-floor",
    title: "Spaces | Tables",
    icon: TableProperties,
    iconSrc: "url",
    link: links.admin.floors.root(hotelSlug),
  },

  {
    accessKey: "hotel-floor",
    title: "Hall",
    icon: Landmark,
    iconSrc: "url",
    link: links.admin.halls.root(hotelSlug),
  },
  // Menu Management Section
  // {
  //   accessKey: "hotel-menu",
  //   title: "Menu Items",
  //   icon: MenuSquare,
  //   iconSrc: "url",
  //   link: links.admin.menu.root,
  // },
   {
    accessKey: "hotel-menu",
    title: "Menu Items",
    icon: MenuSquare,
    iconSrc: "url",
     link: links.admin.menu.root(hotelSlug),
  },
  {
    accessKey: "hotel-menu",
    title: "Menu Category",
    icon: CopySlash,
    iconSrc: "url",
    link: links.admin.category.root(hotelSlug),
  },
  {
    accessKey: "hotel-order",
    title: "Order History",
    icon: ClipboardList,
    iconSrc: "url",
    link: links.admin.orders.history(hotelSlug),
  },
  {
    accessKey: "hotel-settings",
    title: "QR Codes",
    icon: QrCode,
    iconSrc: "url",
    link: links.admin.qrCode.root(hotelSlug),
  },
  // Restaurant Layout Section
  // Inventory Section
  // Customer Management Section
  {
    accessKey: "hotel-settings",
    title: "Customers",
    icon: UsersRound,
    iconSrc: "url",
    link: links.admin.customers.root(hotelSlug),
  },
  {
  accessKey: "hotel-settings",
  title: "Feedback",
  icon: Star,
  iconSrc: "url",
  link: links.admin.review.root(hotelSlug),
},
  // Staff Management Section
  {
    accessKey: "hotel-user",
    title: "Staff Login",
    icon: UserCog,
    iconSrc: "url",
    link: links.admin.users.root(hotelSlug),
  },
  // Marketing Section
  {
    accessKey: "hotel-settings",
    title: "Coupons",
    icon: UsersRound,
    iconSrc: "url",
    link: links.admin.coupon.root(hotelSlug),
  },
  {
    accessKey: "hotel-settings",
    title: "Banners",
    icon: ImageIcon,
    iconSrc: "url",
    link: links.admin.gallery.root(hotelSlug),
  },
  // Restaurant Settings Section
  {
    accessKey: "hotel-settings",
    title: "Restro Status",
    icon: Store,
    iconSrc: "url",
    link: links.admin.status.root(hotelSlug),
  },
  {
    accessKey: "hotel-settings",
    title: "Restro Timings",
    icon: Clock,
    iconSrc: "url",
    link: links.admin.timing.root(hotelSlug),
  },
  {
    accessKey: "hotel-settings",
    title: "Tax & Tokens",
    icon: Receipt,
    iconSrc: "url",
    link: links.admin.tokenAmounts.root(hotelSlug),
  },
  {
    accessKey: "hotel-user",
    featureKey: "Employee-Management",
    title: "Employees",
    icon: Users,
    iconSrc: "url",
    link: links.admin.employees.root(hotelSlug),
  },
  {
    accessKey: "hotel-settings",
    featureKey: "Inventory-Management",
    title: "Inventory",
    icon: Package,
    iconSrc: "url",
    link: links.admin.inventory.root,
  },
  {
    accessKey: "hotel-settings",
    title: "Integrations",
    icon: CreditCard,
    iconSrc: "url",
    link: links.admin.integrations.root(hotelSlug),
  },
  {
    accessKey: "hotel-outlet",
    title: "Outlet List",
    icon: Landmark,
    iconSrc: "url",
    link: links.admin.outlet.list,
  },
  {
    accessKey: "hotel-floor",
    title: "Footer Reciept",
    icon: Landmark,
    iconSrc: "url",
    link: links.admin.outlet.receipt,
  },
  //   {
  //   accessKey: "hotel-settings",
  //   title: "Integrations",
  //   icon: CreditCard,
  //   iconSrc: "url",
  //   link: links.admin.integrations.listgateways,
  // },
]

const footerMenuItems = []

class AdminNavigation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // menuItems: menuItems,
      menuItems: menuItems(props.hotels[0]?.hotel_slug || ''),
      
      activeMenuIndex: 0,
      isSidebarOpen: window.innerWidth >= 768,
      isMobile: window.innerWidth < 1360,
      shortCutTopMenuItems: [
        {
          accessKey: "hotel-order",
          title: "Dine In",
          icon: Utensils,
          iconSrc: "url",
          link: links.admin.customBilling.dineIn(this.props.hotels[0]?.hotel_slug || ''),
          color: "#F0A0A0",
          badge: 0,
        },
        {
          accessKey: "hotel-order",
          title: "Pickup",
          icon: ShoppingBag,
          iconSrc: "url",
          link: links.admin.orders.list(this.props.hotels[0]?.hotel_slug || ''),
          color: "#FFC063",
          badge: 0,
        },
        {
          accessKey: "hotel-booking",
          title: "Booking",
          icon: Calendar,
          iconSrc: "url",
          link: links.admin.bookings.root(this.props.hotels[0]?.hotel_slug || ''),
          color: "#A294E0",
          badge: 0,
        },
        {
          accessKey: "hotel-order",
          title: "Digital Token",
          icon: Ticket,
          iconSrc: "url",
          link: links.admin.digitalToken.root(this.props.hotels[0]?.hotel_slug || ''),
          color: "#4C91FF",
          badge: 0,
        },
        {
          accessKey: "hotel-order",
          title: "In house Payment",
          icon: CreditCard,
          iconSrc: "url",
          link: links.admin.payments.root(this.props.hotels[0]?.hotel_slug || ''),
          color: "#F0A0A0",
          badge: 0,
        },
      ],
      plandata: [],
      activeFeatures: [],
      currentPlan: null,
      activePlan: null,
      isPlanActive: false,
      toast: {
        open: false,
        message: "",
        severity: "success",
      },
      // Previous counts for comparison
      previousPickupCount: 0,
      previousBookingsCount: 0,
      previousActiveTableCount: 0,
      previousPaymentRequestCount: 0,
      previousWaitingTableCount: 0,
    }

    // Socket.IO instance reference
    this.socket = null
    this.toggleSidebar = this.toggleSidebar.bind(this)
    this.handleMenuClick = this.handleMenuClick.bind(this)
    this.handleShortcutClick = this.handleShortcutClick.bind(this)
    this.handleResize = this.handleResize.bind(this)
      console.log("AdminNavigation constructor", props.hotels[0]?.hotel_slug)

  }

  showToast = (message, severity = "success") => {
    this.setState({
      toast: {
        open: true,
        message,
        severity,
      },
    })
  }

  handleCloseToast = (event, reason) => {
    if (reason === "clickaway") {
      return
    }
    this.setState({
      toast: {
        ...this.state.toast,
        open: false,
      },
    })
  }

    startBadgePolling = () => {
    // Clear any existing interval first
    if (this.badgeInterval) {
      clearInterval(this.badgeInterval);
    }
    
    // Set up new interval (7000ms = 7 seconds)
    // this.badgeInterval = setInterval(() => {
    //   this.getBadgeCount();
    // }, 10000);

    // Initial call
    this.getBadgeCount();
  };

  // Stop badge polling
  stopBadgePolling = () => {
    if (this.badgeInterval) {
      clearInterval(this.badgeInterval);
    }
  };


getData = async () => {
  try {
    const response = await API(this, "get", URL_PATH.subscriptionPlans)
    const {
      status,
      data,
      message,
      currentPlan = null,
      isPlanActive,
    } = response
    
    if (status === "success") {
      let activePlan = null
      let activeFeatures = []
      
      if (currentPlan && currentPlan.plan_id) {
        activePlan = data.find((plan) => plan.id === currentPlan.plan_id)
        if (activePlan) {
          activeFeatures = activePlan.features || []
          activePlan = {
            ...activePlan,
            subscription_id: currentPlan.id,
            starts_at: currentPlan.starts_at,
            ends_at: currentPlan.ends_at,
            trial_ends_at: currentPlan.trial_ends_at,
            payment_method: currentPlan.payment_method,
          }
        }
      }

      // Only navigate to subscription page if plan is not active
      if (!isPlanActive) {
        this.props.props.history.push(routes.admin.subscription.root)
      }

      this.setState({
        status,
        plandata: data,
        activeFeatures,
        currentPlan,
        activePlan,
        isPlanActive,
      })
    } else {
      // Use the state-based toast instead of this.toast
      this.showToast(message, "error")
    }
  } catch (error) {
    console.error("Error fetching data:", error)
    this.showToast("Error fetching data", "error")
  }
}

  // Initialize Socket.IO connection
  initializeSocketIO = () => {
    try {
      console.log("[Socket.IO] Initializing Socket.IO connection...")
      const hotelId = this.props.selectedHotelId?.id
      if (!hotelId) {
        console.error("❌ Hotel ID not available for Socket.IO connection")
        return
      }

      // Initialize socket connection using your socket service
      this.socket = initSocket(String(hotelId))

      // Set up connection event handlers
      this.setupConnectionHandlers()

      // Subscribe to Socket.IO channels
      this.subscribeToSocketIOChannels()
    } catch (error) {
      console.error("❌ Error initializing Socket.IO:", error)
    }
  }

  // Setup Socket.IO connection handlers
  setupConnectionHandlers = () => {
    if (!this.socket) return

    this.socket.on("connect", () => {
      console.log("✅ Socket.IO connected successfully")
      // this.showToast("Connected to real-time updates", "success")
    })

    this.socket.on("disconnect", (reason) => {
      console.log("❌ Socket.IO disconnected:", reason)
      // this.showToast("Disconnected from real-time updates", "warning")
    })

    this.socket.on("reconnect", (attemptNumber) => {
      console.log("🔄 Socket.IO reconnected after", attemptNumber, "attempts")
      this.showToast("Reconnected to real-time updates", "success")
      // Re-fetch data on reconnection
      this.getBadgeCount()
    })

    this.socket.on("connect_error", (error) => {
      console.error("❌ Socket.IO connection error:", error)
    })
  }

  // Subscribe to Socket.IO channels
  subscribeToSocketIOChannels = () => {
    try {
      const hotelId = this.props.selectedHotelId?.id
      if (!hotelId || !this.socket) {
        console.error("❌ Hotel ID or Socket instance not available")
        return
      }

      console.log(`[Socket.IO] Subscribing to badge events for hotel: ${hotelId}`)

      // Remove existing listeners to avoid duplicates
      this.socket.off(`etable_database_hotel.badges.${hotelId}:hotel-events`)

      // Subscribe to badge updates
      this.socket.on(`etable_database_hotel.badges.${hotelId}:hotel-events`, (data) => {
        console.log("📡 Badge Event Received:", data)
        try {
          const parsedData = typeof data === "string" ? JSON.parse(data) : data
          if (parsedData.type === "data") {
            this.handleBadgesUpdate(parsedData.data)
          } else if (parsedData.type === "message") {
            console.log("📢 Message type event:", parsedData.message)
            this.showToast(parsedData.message, "info")
          } else {
            console.warn("🔴 Unknown event type:", parsedData.type)
          }
        } catch (error) {
          console.error("❌ Error parsing Socket.IO data:", error)
          console.log("🔴 Raw Data:", data)
        }
      })

      console.log(`✅ Subscribed to badge events for hotel ${hotelId}`)
    } catch (error) {
      console.error("❌ Error subscribing to Socket.IO channels:", error)
    }
  }

  // Handle badges update from Socket.IO - Same logic as before
  handleBadgesUpdate = (badgeData) => {
    console.log("🔄 Updating badges from Socket.IO event:", badgeData)
    // Extract counts with proper null handling and space handling for waitingTableCount
    const {
      pickupPendingCount = 0,
      bookingsCount = 0,
      activeTableCount = 0,
      paymentRequestsCount = 0,
      // Handle both "waitingTableCount" and "waitingTableCount " (with space)
      ["waitingTableCount"]: waitingCount1 = 0,
      ["waitingTableCount "]: waitingCount2 = 0,
    } = badgeData

    const waitingTableCount = waitingCount1 || waitingCount2 || 0

    // Convert null values to 0 explicitly
    const normalizedCounts = {
      pickupPendingCount: pickupPendingCount || 0,
      bookingsCount: bookingsCount || 0,
      activeTableCount: activeTableCount || 0,
      paymentRequestsCount: paymentRequestsCount || 0,
      waitingTableCount: waitingTableCount || 0,
    }

    console.log("📊 Normalized badge counts:", normalizedCounts)

    // Get previous counts for comparison
    const {
      previousPickupCount = 0,
      previousBookingsCount = 0,
      previousActiveTableCount = 0,
      previousPaymentRequestCount = 0,
      previousWaitingTableCount = 0,
    } = this.state

    // Check if new requests arrived
    const newRequests = {
      Pickup: normalizedCounts.pickupPendingCount > previousPickupCount,
      Booking: normalizedCounts.bookingsCount > previousBookingsCount,
      ActiveTable: normalizedCounts.activeTableCount > previousActiveTableCount,
      Payment: normalizedCounts.paymentRequestsCount > previousPaymentRequestCount,
      WaitingTable: normalizedCounts.waitingTableCount > previousWaitingTableCount,
    }

    // Collect all new notifications
    // const notificationMessages = Object.entries(newRequests)
    //   .filter(([_, isNew]) => isNew)
    //   .map(([type]) => `New ${type} Request Received!`)

    // // Queue notifications if there are new messages
    // if (notificationMessages.length > 0) {
    //   notificationMessages.forEach((msg) => this.showNotification(msg))
    // }

    // Create updated shortcut menu items with new badge counts
    const updatedShortCutTopMenuItems = [
      {
        accessKey: "hotel-order",
        title: "Dine In",
        icon: Utensils,
        iconSrc: "url",
        link: links.admin.customBilling.dineIn(this.props.hotels[0]?.hotel_slug || ''),
        color: "#F0A0A0",
        badge: normalizedCounts.activeTableCount,
      },
      {
        accessKey: "hotel-order",
        title: "Pickup",
        icon: ShoppingBag,
        iconSrc: "url",
        link: links.admin.orders.list(this.props.hotels[0]?.hotel_slug || ''),
        color: "#FFC063",
        badge: normalizedCounts.pickupPendingCount,
      },
      {
        accessKey: "hotel-booking",
        title: "Booking",
        icon: Calendar,
        iconSrc: "url",
        link: links.admin.bookings.root(this.props.hotels[0]?.hotel_slug || ''),
        color: "#A294E0",
        badge: normalizedCounts.bookingsCount,
      },
      {
        accessKey: "hotel-order",
        title: "Digital Token",
        icon: Ticket,
        iconSrc: "url",
        link: links.admin.digitalToken.root(this.props.hotels[0]?.hotel_slug || ''),
        color: "#4C91FF",
        badge: normalizedCounts.waitingTableCount,
      },
      {
        accessKey: "hotel-order",
        title: "In house Payment",
        icon: CreditCard,
        iconSrc: "url",
        link: links.admin.payments.root(this.props.hotels[0]?.hotel_slug || ''),
        color: "#F0A0A0",
        badge: normalizedCounts.paymentRequestsCount,
      },
    ]

    console.log(
      "🎯 Updated menu items with badges:",
      updatedShortCutTopMenuItems.map((item) => ({ title: item.title, badge: item.badge })),
    )

    // Force immediate state update with callback to ensure re-render
    this.setState(
      {
        previousPickupCount: normalizedCounts.pickupPendingCount,
        previousBookingsCount: normalizedCounts.bookingsCount,
        previousActiveTableCount: normalizedCounts.activeTableCount,
        previousPaymentRequestCount: normalizedCounts.paymentRequestsCount,
        previousWaitingTableCount: normalizedCounts.waitingTableCount,
        shortCutTopMenuItems: updatedShortCutTopMenuItems,
      },
      () => {
        console.log("✅ State updated successfully, badges should now reflect:", {
          dineIn: normalizedCounts.activeTableCount,
          pickup: normalizedCounts.pickupPendingCount,
          booking: normalizedCounts.bookingsCount,
          digitalToken: normalizedCounts.waitingTableCount,
          payment: normalizedCounts.paymentRequestsCount,
        })
        // Force a re-render if needed
        this.forceUpdate()
      },
    )
  }

  // Cleanup Socket.IO connections
  cleanupSocketIO = () => {
    try {
      console.log("[Socket.IO] Cleaning up connections...")
      if (this.socket) {
        const hotelId = this.props.selectedHotelId?.id
        if (hotelId) {
          // Remove specific event listeners
          this.socket.off(`etable_database_hotel.badges.${hotelId}:hotel-events`)
        }

        // Remove connection event listeners
        this.socket.off("connect")
        this.socket.off("disconnect")
        this.socket.off("reconnect")
        this.socket.off("connect_error")

        // Note: Don't disconnect the socket here as it might be used by other components
        // Let the socket service handle the connection lifecycle
        this.socket = null
      }
      console.log("✅ Socket.IO cleanup completed")
    } catch (error) {
      console.error("❌ Error during Socket.IO cleanup:", error)
    }
  }

  toggleSidebar() {
    this.setState((prevState) => ({
      isSidebarOpen: !prevState.isSidebarOpen,
    }))
  }

  handleMenuClick(index) {
    console.log("index", index)
    this.setState({
      activeMenuIndex: index,
      activeshortCutTopMenuIndex: -1,
    })
    // Close sidebar on mobile after menu item click
    if (this.state.isMobile) {
      this.setState({ isSidebarOpen: false })
    }
  }

  handleShortcutClick(index) {
    this.setState({
      activeMenuIndex: -1,
      activeshortCutTopMenuIndex: index,
    })
  }

  filterMenuItems = () => {
    const { accessControl } = this.props
    const { activeFeatures } = this.state
    console.group("filterMenuItems Debug")
    console.log("Input - accessControl:", accessControl)
    console.log("Input - activeFeatures:", activeFeatures)
     console.log("Full menuItems:", this.state.menuItems)
  const filteredItems = this.state.menuItems.filter((item) => {
      const { accessKey, featureKey } = item
      let shouldInclude = true
      // Check access control
      if (!accessControl.includes(accessKey)) {
        shouldInclude = false
      }
      // Check feature availability if access check passed
      else if (featureKey) {
        const hasFeature = activeFeatures.some((f) => {
          const match = f.tag.includes(featureKey)
          return match
        })
        if (!hasFeature) {
          shouldInclude = false
        } else {
        }
      } else {
      }
      console.groupEnd()
      return shouldInclude
    })
    console.log("Final filtered items:", filteredItems)
    console.groupEnd()
    return filteredItems
  }

  // Updated getBadgeCount - now only called on initial load and Socket.IO events
  getBadgeCount = async () => {
    try {
      const { status, data } = await API(this, "get", URL_PATH.badges, {}, {}, false)
      if (status === "success") {
        // Handle the badge update using the same logic as Socket.IO
        this.handleBadgesUpdate(data)
      }
    } catch (error) {
      console.error("Error fetching badges:", error)
      // Optional: Show error to user
      // this.showToast("Failed to update notification badges", "error");
    }
  }

  // Helper function to show notifications
  showNotification = (message) => {
    this.setState({ showNotification: true, notificationMessage: message })
    // Auto-hide after 30s
    setTimeout(() => this.setState({ showNotification: false }), 30000)
  }

  handleResize() {
    const isMobile = window.innerWidth < 1360
    this.setState({
      isSidebarOpen: !isMobile,
      isMobile: isMobile,
    })
  }

  async componentDidMount() {
    console.log("🚀 AdminNavigation componentDidMount")
    try {
      // Get initial badge count and data
    this.startBadgePolling();
      await this.getData()
      // Set up URL-based active menu
      const url = window.location.pathname
    const activeMenuIndex = this.state.menuItems.findIndex((item) => item.link === url)
      this.setState({
        activeMenuIndex,
        isMobile: window.innerWidth < 1360,
      })
      // Initialize Socket.IO if hotel ID exists
      if (this.props.selectedHotelId?.id) {
        this.initializeSocketIO()
      }
      // Add resize listener
      window.addEventListener("resize", this.handleResize)
    } catch (error) {
      console.error("❌ Error in componentDidMount:", error)
    }
  }

  componentDidUpdate(prevProps) {
    // Initialize Socket.IO when hotel ID becomes available
    if (
      this.props.selectedHotelId?.id &&
      this.props.selectedHotelId.id !== prevProps.selectedHotelId?.id &&
      !this.socket
    ) {
      console.log("🔄 Hotel ID changed, initializing Socket.IO...")
      this.initializeSocketIO()
    }
  }

  componentWillUnmount() {
    console.log("🧹 AdminNavigation componentWillUnmount")
    // Cleanup Socket.IO connections
        this.stopBadgePolling();

    this.cleanupSocketIO()
    // Remove event listeners
    window.removeEventListener("resize", this.handleResize)
  }

  handleLogout = () => {
    logOut(this.props.props)
  }

  render() {
    const { isSidebarOpen, isMobile } = this.state
    const filteredMenuItems = this.filterMenuItems()
    const daysRemaining = this.state.currentPlan ? moment(this.state.currentPlan.ends_at).diff(moment(), "days") : null

    // Debug: Log current badge values being rendered
    console.log(
      "🎨 Rendering badges:",
      this.state.shortCutTopMenuItems.map((item) => ({
        title: item.title,
        badge: item.badge,
      })),
    )
    console.log("daysRemainingdaysRemaining", daysRemaining)

    return (
      <Box
        style={{
          maxHeight: "100vh",
          overflow: "hidden",
          minHeight: "100vh",
          position: "relative",
        }}
      >
        <Toast
          open={this.state.toast.open}
          message={this.state.toast.message}
          severity={this.state.toast.severity}
          onClose={this.handleCloseToast}
        />
        {/* Sidebar */}
        {this.state.showNotification && <Notification message={this.state.notificationMessage} />}
        {/* Mobile Sidebar */}
        {isMobile && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              bottom: 0,
              width: "250px", // Fixed width for mobile
              backgroundColor: "#041A29",
              backgroundImage: "none",
              zIndex: 1000,
              transform: isSidebarOpen ? "translateX(0)" : "translateX(-100%)",
              transition: "transform 0.3s ease-in-out",
              display: "flex",
              flexDirection: "column",
              boxShadow: isSidebarOpen ? "0 0 15px rgba(0, 0, 0, 0.5)" : "none",
            }}
          >
            {/* Sidebar header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "15px",
                borderBottom: "1px solid #424242",
              }}
            >
              <Link to={links.admin.dashboard.root}>
                <img
                  src="https://etableapp.in/logo2.png"
                  style={{
                    width: "90px",
                    height: "auto",
                    objectFit: "contain",
                  }}
                />
              </Link>
              {/* Close button for mobile */}
              <button
                onClick={this.toggleSidebar}
                style={{
                  background: "transparent",
                  border: "2px solid #07070A",
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    color: "#FBBF24",
                  }}
                >
                  <path
                    d="M18 6L6 18M6 6l12 12"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </div>
            {/* Sidebar content */}
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
                msOverflowStyle: "none",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              {/* Main menu items */}
              <div
                style={{
                  padding: "10px",
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {filteredMenuItems.map((item, index) => {
                  const { accessKey, title, link, icon: IconComponent } = item
                  const isActive = this.state.activeMenuIndex === index
                  if (this.props.accessControl.includes(accessKey)) {
                    return (
                      <Button
                        key={index}
                        component={Link}
                        to={link}
                        onClick={() => this.handleMenuClick(index)}
                        startIcon={
                          <IconComponent size={20} color={isActive ? "#FFC857" : "white"} style={{ flexShrink: 0 }} />
                        }
                        style={{
                          justifyContent: "flex-start",
                          textAlign: "left",
                          width: "100%",
                          marginBottom: "5px",
                          backgroundColor: this.state.activeMenuIndex === index ? Colors.rootBgColor : "transparent",
                          color: "white",
                          textTransform: "none",
                          borderRight: this.state.activeMenuIndex === index ? "4px solid #FFC857" : "none",
                          paddingRight: this.state.activeMenuIndex === index ? "11px" : "15px",
                          paddingLeft: "15px",
                          transition: "all 0.2s ease-in-out",
                          whiteSpace: "nowrap", // Prevent text wrapping
                          overflow: "hidden", // Hide overflow
                        }}
                      >
                        <Text
                          bold
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {title}
                        </Text>
                      </Button>
                    )
                  }
                  return null
                })}
              </div>
            </div>
          </div>
        )}

        {/* Desktop Sidebar */}
        {!isMobile && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              bottom: 0,
              width: isSidebarOpen ? "200px" : "60px",
              backgroundColor: "#041A29",
              backgroundImage: "none",
              zIndex: 1000,
              transition: "all 0.3s ease-in-out",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {/* Sidebar header */}
            <div
              style={{
                display: "flex",
                justifyContent: isSidebarOpen ? "center" : "none",
                alignItems: "center",
                padding: isSidebarOpen ? "15px " : "10px 0",
                borderBottom: "1px solid #424242",
              }}
            >
              {/* Toggle button - always visible */}
              <button
                onClick={this.toggleSidebar}
                style={{
                  background: "transparent",
                  border: "2px solid #07070A",
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  cursor: "pointer",
                  margin: isSidebarOpen ? "0 10px 0 0" : "0",
                  transition: "all 0.3s ease-in-out",
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{
                    color: "#FBBF24",
                    transform: isSidebarOpen ? "rotate(0deg)" : "rotate(180deg)",
                    transition: "transform 0.3s ease-in-out",
                  }}
                >
                  <path
                    d="M15 19L8 12L15 5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              {/* Logo - only visible when sidebar is open */}
              {isSidebarOpen && (
                <Link to={links.admin.dashboard.root}>
                  <img
                    src={EtableNew || "/placeholder.svg"}
                    style={{
                      width: "90px",
                      paddingTop: "14px",
                      paddingBottom: "10px",
                      height: "auto",
                      objectFit: "contain",
                    }}
                  />
                </Link>
              )}
            </div>
            {/* Sidebar content */}
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
                msOverflowStyle: "none",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
              }}
            >
              {/* Main menu items */}
              <div
                style={{
                  padding: isSidebarOpen ? "10px 10px 0 10px" : "10px 0 0 0",
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: isSidebarOpen ? "flex-start" : "center",
                }}
              >
                {filteredMenuItems.map((item, index) => {
                  const { accessKey, title, link, icon: IconComponent } = item
                  const isActive = this.state.activeMenuIndex === index
                  if (this.props.accessControl.includes(accessKey)) {
                    return (
                      <DarkTooltip
                        key={index}
                        title={title}
                        placement="right"
                        arrow
                        disableHoverListener={isSidebarOpen} // Only show tooltip when sidebar is collapsed
                      >
                        <Button
                          component={Link}
                          to={link}
                          onClick={() => this.handleMenuClick(index)}
                          style={{
                            justifyContent: isSidebarOpen ? "flex-start" : "center",
                            textAlign: "left",
                            width: "100%",
                            marginBottom: "5px",
                            backgroundColor: this.state.activeMenuIndex === index ? Colors.rootBgColor : "transparent",
                            color: "white",
                            textTransform: "none",
                            borderRight: this.state.activeMenuIndex === index ? "4px solid #FFC857" : "none",
                            // paddingRight: this.state.activeMenuIndex === index ? "11px" : "15px",
                            paddingLeft: isSidebarOpen ? "15px" : "0",
                            minWidth: "0",
                            padding: isSidebarOpen ? "5px 15px" : "8px 0",
                            transition: "all 0.3s ease-in-out",
                            overflow: "hidden",
                            whiteSpace: "nowrap", // Prevent text wrapping
                          }}
                        >
                          <IconComponent
                            size={20}
                            color={isActive ? "#FFC857" : "white"}
                            style={{
                              marginRight: isSidebarOpen ? 8 : 0,
                              transition: "margin-right 0.3s ease-in-out",
                              flexShrink: 0, // Prevent icon from shrinking
                            }}
                          />
                          {isSidebarOpen && (
                            <Text
                              bold
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "120px", // Limit text width
                              }}
                            >
                              {title}
                            </Text>
                          )}
                        </Button>
                      </DarkTooltip>
                    )
                  }
                  return null
                })}
              </div>
            </div>
          </div>
        )}

        {/* Overlay for mobile when sidebar is open */}
        {isMobile && isSidebarOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 999,
            }}
            onClick={this.toggleSidebar}
          />
        )}

        {/* Main content wrapper */}
        <div
          style={{
            marginLeft: isMobile ? 0 : isSidebarOpen ? "200px" : "60px",
            transition: "all 0.3s ease-in-out",
            width: "calc(100% - " + (isMobile ? 0 : isSidebarOpen ? 200 : 60) + "px)",
          }}
        >
          {/* Top bar */}
          <div
            id="top-bar"
            style={{
              backgroundColor: "#02111B",
              borderBottom: "1px solid #424242",
              position: "sticky",
              top: 0,
              zIndex: 998,
            }}
            className="d-flex flex-row justify-content-between flex-wrap align-items-center"
          >
            <div className="d-flex flex-row p-3 flex-wrap align-items-center">
              {/* Mobile menu toggle button - only show below 1360px */}
              {isMobile && (
                <button
                  onClick={this.toggleSidebar}
                  style={{
                    background: "transparent",
                    border: "2px solid #07070A",
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "pointer",
                    marginRight: "10px",
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style={{
                      color: "#FBBF24",
                    }}
                  >
                    <path
                      d="M9 5L16 12L9 19"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              )}
              {/* Logo - always show on mobile */}
              {isMobile && (
                <Link to={links.admin.dashboard.root}>
                  <img
                    src="https://etableapp.in/logo2.png"
                    style={{
                      width: "100px",
                      height: "auto",
                      objectFit: "contain",
                      margin: "5px 35px 5px 5px",
                      cursor: "pointer",
                    }}
                  />
                </Link>
              )}
              {/* Top menu items section */}
              <div>
                {/* Popup for mobile view (shown below 1360px) */}
                {this.state.showMobileMenuPopup && isMobile && (
                  <div
                    style={{
                      position: "fixed",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: "rgba(0,0,0,0.9)",
                      zIndex: 1000,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      padding: "20px",
                    }}
                  >
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        maxWidth: "400px",
                        maxHeight: "80vh",
                        backgroundColor: "#02111B",
                        borderRadius: "8px",
                        padding: "40px 20px 20px",
                        overflowY: "auto",
                        boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
                      }}
                    >
                      {/* Close button */}
                      <button
                        onClick={() => this.setState({ showMobileMenuPopup: false })}
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          background: "none",
                          border: "none",
                          color: "white",
                          fontSize: "20px",
                          cursor: "pointer",
                          padding: "5px 10px",
                          borderRadius: "50%",
                          zIndex: 1001,
                        }}
                        aria-label="Close menu"
                      >
                        &#10005;
                      </button>
                      {/* Menu items in popup */}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >
                        {this.state.shortCutTopMenuItems.map((item, index) => {
                          const {
                            accessKey,
                            iconSrc = "url",
                            icon: IconComponent,
                            title,
                            link,
                            color,
                            badge = 0,
                          } = item
                          if (!this.props.accessControl.includes(accessKey)) return null
                          return (
                            <Link
                              key={index}
                              style={{
                                textDecoration: "none",
                                flexDirection: "row",
                                display: "flex",
                                alignItems: "center",
                                borderWidth: 1,
                                borderStyle: "solid",
                                borderTopColor: this.state.activeshortCutTopMenuIndex == index ? color : "transparent",
                                borderRightColor:
                                  this.state.activeshortCutTopMenuIndex == index ? color : "transparent",
                                borderBottomColor:
                                  this.state.activeshortCutTopMenuIndex == index ? color : "transparent",
                                padding: "15px 20px",
                                backgroundColor:
                                  this.state.activeshortCutTopMenuIndex == index ? Colors.rootBgColor : "#041A29",
                                borderLeft: `10px solid ${color}`,
                                width: "100%",
                                borderRadius: "4px",
                              }}
                              onClick={() => {
                                this.handleShortcutClick(index)
                                this.setState({ showMobileMenuPopup: false })
                              }}
                              to={item.link}
                            >
                              <div style={styles.desktopNavigationMenuItemIcon}>
                                <IconComponent size={24} color="white" />
                              </div>
                              <Text style={{ ...styles.desktopNavigationMenuItemTitle, marginLeft: "15px" }} bold>
                                {item.title}
                              </Text>
                              {badge > 0 && (
                                <div
                                  style={{
                                    backgroundColor: "#BB0A21",
                                    color: "white",
                                    borderRadius: 16,
                                    padding: "5px 12px",
                                    marginLeft: "auto",
                                    fontSize: 14,
                                  }}
                                >
                                  {badge}
                                </div>
                              )}
                            </Link>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                )}
                {/* Desktop view - original shortcut items (shown above 1360px) */}
                {!isMobile && (
                  <div className="d-flex flex-row flex-wrap align-items-center">
                    {this.state.shortCutTopMenuItems.map((item, index) => {
                      const { accessKey, iconSrc = "url", icon: IconComponent, title, link, color, badge = 0 } = item
                      if (!this.props.accessControl.includes(accessKey)) return null
                      return (
                        <Link
                          key={index}
                          style={{
                            textDecoration: "none",
                            flexDirection: "row",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderWidth: 1,
                            borderStyle: "solid",
                            borderTopColor: this.state.activeshortCutTopMenuIndex == index ? color : "transparent",
                            borderRightColor: this.state.activeshortCutTopMenuIndex == index ? color : "transparent",
                            borderBottomColor: this.state.activeshortCutTopMenuIndex == index ? color : "transparent",
                            padding: "10px 12px",
                            backgroundColor:
                              this.state.activeshortCutTopMenuIndex == index ? Colors.rootBgColor : "#041A29",
                            margin: "2px 10px 0px 10px",
                            borderLeft: `10px solid ${color}`,
                            minWidth: "150px",
                          }}
                          onClick={() => this.handleShortcutClick(index)}
                          to={item.link}
                        >
                          <div style={styles.desktopNavigationMenuItemIcon}>
                            <IconComponent size={24} color="white" />
                          </div>
                          {this.props.drawerShown && (
                            <Text style={styles.desktopNavigationMenuItemTitle} bold>
                              {item.title}
                            </Text>
                          )}
                          {badge > 0 && (
                            <div
                              style={{
                                backgroundColor: "#BB0A21",
                                color: "white",
                                borderRadius: 16,
                                padding: "5px 12px",
                                marginLeft: "auto",
                                fontSize: 14,
                                marginLeft: 10,
                              }}
                            >
                              {badge}
                            </div>
                          )}
                        </Link>
                      )
                    })}
                  </div>
                )}
              </div>
            </div>
            {/* Fixed position for logout button and hamburger icon */}
            <div
              style={{
                position: "fixed",
                right: "5px",
                display: "flex",
                alignItems: "center",
                // gap: '10px'
              }}
            >
              <LogoutButton props={this.props.props} />
              {isMobile && (
                <button
                  onClick={() => this.setState({ showMobileMenuPopup: true })}
                  style={{
                    background: "none",
                    border: "none",
                    color: "white",
                    fontSize: "28px",
                    cursor: "pointer",
                    padding: "5px",
                  }}
                  aria-label="Open menu"
                >
                  ☰
                </button>
              )}
            </div>
          </div>
          {/* Main content */}
          <div
            style={{
              padding: "20px",
              height: "calc(100vh - 60px)",
              overflowY: "auto",
            }}
          >
            {this.props.children}
          </div>
        </div>
        {/* {daysRemaining !== null && daysRemaining <= 5 && this.props.props.auth.user_type !== "hotel-user" && (
          <div
            style={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              backgroundColor: Colors.drawerBgColor,
              padding: "15px",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              zIndex: 1000,
              maxWidth: "300px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Text center style={{ marginBottom: "10px" }}>
              Your plan will expire in {daysRemaining} days
            </Text>
            <Button
              onClick={() => {
                this.props.navigate(links.admin.settings.subscription, {
                  state: { type: "renew" },
                })
              }}
              style={{
                backgroundColor: Colors.redColor,
                color: "white",
                padding: "8px 16px",
                borderRadius: "4px",
                textTransform: "none",
                fontWeight: "bold",
              }}
            >
              Renew Now
            </Button>
          </div>
        )} */}
        {/* Missing Features Notification - Only show if more than 5 days remaining */}
        {/* {this.state.notIncludedFeatureCount > 0 && daysRemaining > 5 && this.props.props.auth.user_type !== "hotel-user" && (
          <div
            style={{
              position: "fixed",
              bottom: "20px",
              right: "20px",
              backgroundColor: Colors.background,
              padding: "15px",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              zIndex: 1000,
              maxWidth: "300px",
            }}
          >
            <Text center style={{ marginBottom: "10px" }}>
              {this.state.notIncludedFeatureCount} useful features are not included in your subscription:{" "}
              {this.state.features_not_available_array}
            </Text>
            <Button
              onClick={() => {
                this.props.navigate(links.admin.settings.subscription, {
                  state: { type: "upgrade" },
                })
              }}
              style={{
                backgroundColor: Colors.primary,
                color: "black",
                padding: "8px 16px",
                borderRadius: "4px",
                textTransform: "none",
                fontWeight: "bold",
                marginTop: "10px",
              }}
            >
              Upgrade Now
            </Button>
          </div>
        )} */}
      </Box>
    )
  }
}

export default Redux(AdminNavigation)

const styles = {
  desktopNavigationContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    overflowY: "auto",
    backgroundColor: "#212121",
    minHeight: "calc(100vh - 61px)",
    overflowX: "hidden",
    maxHeight: "calc(100vh - 61px)",
    overflowY: "auto",
  },
  desktopNavigationLogo: {
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
  },
  desktopNavigationMenu: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: Colors.pageBgColor,
    overflowX: "hidden",
    minHeight: document.documentElement.clientHeight - 90,
    maxHeight: document.documentElement.clientHeight - 90,
    overflowY: "auto",
    justifyContent: "space-between",
  },
  desktopNavigationMenuItem: {
    color: "white",
    display: "flex",
    flexDirection: "column",
  },
  desktopNavigationMenuItemIcon: {
    width: "auto",
    height: "auto",
    maxWidth: "100%",
    maxHeight: "100%",
    display: "flex",
    justifyContent: "center",
    marginRight: "10px",
    color: "white",
    minWidth: "23px",
  },
  desktopNavigationMenuItemTitle: {
    width: "auto",
    height: "auto",
    maxWidth: "100%",
    maxHeight: "100%",
    display: "flex",
    justifyContent: "center",
    color: "white",
  },
  desktopNavigationMenuItemArrow: {
    width: "auto",
    height: "auto",
    maxWidth: "100%",
    maxHeight: "100%",
    display: "flex",
    justifyContent: "center",
    color: "white",
    marginLeft: "auto",
  },
}
